import { render } from "./TokenLogo.vue?vue&type=template&id=fbac74d8&scoped=true"
import script from "./TokenLogo.vue?vue&type=script&lang=js"
export * from "./TokenLogo.vue?vue&type=script&lang=js"

import "./TokenLogo.vue?vue&type=style&index=0&id=fbac74d8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbac74d8"]])

export default __exports__